import { footer_links } from './footerLinks';
import {
  financial_advice_navigation_links,
  products_navigation_links,
  resources_navigation_links,
} from './navigationLinks';
import {
  financial_advice_promo_card,
  products_promo_card,
  resources_promo_card,
} from './promoCards';

export const navigation: Record<string, Record<string, string>> = {
  products_navigation_links,
  products_promo_card,
  financial_advice_navigation_links,
  footer_links,
  resources_navigation_links,
  resources_promo_card,
  financial_advice_promo_card,
} as const;
